import React, { useState } from "react";
import { Card } from "primereact/card";
import { Paginator } from "primereact/paginator";
import "./BlogSection.scss";
import { usePosts } from "../../custom-hooks";
import rightArrow from "../../Media/leftarrow.svg";

const BlogSection = () => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(6);

  const [blogs] = usePosts();

  const sortedBlogs = [...blogs]
    .sort((a, b) => new Date(b.sys.createdAt) - new Date(a.sys.createdAt))
    .slice(first, first + rows);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <>
      <div className="blog-content-section aln_Pos">
        <div className="grid m-0 p-0">
          <div className="col-12 m-0 p-0">
            <Card className="flex flex-column blog-card-section flex-wrap pa_25_">
              <div className="max_Width">
                <div>
                  <h2 className="flex blog-section-heading">Althi Blog</h2>
                </div>

                <div
                  className="flex align-items-center card-content flex_W g_25 w-full"
                  style={{ justifyContent: "flex-start" }}
                >
                  {sortedBlogs.map((blog) => {
                    const image = blog?.fields?.blogImage?.[0]?.fields?.file;

                    const imageUrl = image?.url
                      ? image.url.startsWith("//")
                        ? `https:${image.url}`
                        : image.url
                      : null;

                    return (
                      <a
                        key={blog.sys.id}
                        href={`/blog/${blog.sys.id}`}
                        className="blog-card-link"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <div className="blOG_Item flex flex_D g_15">
                          {imageUrl && (
                            <img
                              className="blOG_"
                              loading="lazy"
                              width={image?.details?.image?.width || 400}
                              height={image?.details?.image?.height || 250}
                              src={imageUrl}
                              alt={
                                blog?.fields?.blogTitle
                                  ? `${blog.fields.blogTitle} featured image`
                                  : "Blog featured image"
                              }
                            />
                          )}

                          <div className="w-full blOG_L">
                            {blog?.fields?.blogAuthor} |{" "}
                            {blog?.fields?.createdDate}
                          </div>

                          <div className="w-full text_W blOG_V">
                            <h3 className="blOG_V">
                              {blog?.fields?.blogTitle}
                            </h3>

                            <div className="bloG_Nav">
                              <img
                                className="whatwedo-small-arrow"
                                src={rightArrow}
                                alt=""
                                width="16px"
                              />
                            </div>
                          </div>
                        </div>
                      </a>
                    );
                  })}
                </div>

                {blogs.length > rows && (
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={blogs.length}
                    rowsPerPageOptions={[6, 12, 18]}
                    onPageChange={onPageChange}
                    template="PrevPageLink PageLinks NextPageLink"
                    className="pa_TB"
                  />
                )}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogSection;
